<script setup>
import ScheduledMessagesMain from '@/components/scheduled/ScheduledMessagesMain.vue'
</script>

<template>
  <scheduled-messages-main />
</template>
